import { createEffect, sample } from 'effector';
import { savedAddressesApi } from '../api/savedAddressesApi';
import { getSavedAddressesFx } from './getSavedAddressesFx';

export const deleteSavedAddressFx = createEffect<string, string>((id) =>
  savedAddressesApi.deleteSavedAddress(id),
);

sample({
  clock: deleteSavedAddressFx.doneData,
  target: getSavedAddressesFx,
});
